import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import CommonComponentForQuestionsAndOption from '../Common/FeedbackGridRowForTeacher';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/styles.css';
import '../../assets/css/login.css';
var Modal = require('react-bootstrap-modal');
const axios = require('axios').default;
var config = require('../../config/config.json');

export default function TeacherFeedback(props) {
  document.title = props.title
  const navigate = useNavigate();

  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));
  //var selectedStudentClassSemester = localStorage.getItem('selectedStudentClassSemester');
  const [modelPopupStatus, setModelPopupStatus] = useState(false);
  const [componentLodignState, setComponentLodignState] = useState(false);
  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [allTeacherQuestionsArray, setTeacherQuestionsArray] = useState([]);
  const [allTeacherAnswersArray, setTeacherAnswersArray] = useState([]);

  useEffect(() => {
    getAllTeacherQuestions();
  }, []);

  function onSubmitTeacherFeedbackClick() {

    let getQuestionsID = [];
    Object.keys(allTeacherQuestionsArray).map(function (key, index) {
      if (key != "Descriptive") {
        var array = JSON.parse("[" + allTeacherQuestionsArray[key] + "]");
        array[0].map((questions, index) => (
          getQuestionsID.push(questions.mafq_auto_id)
        ))
      }
    })

    let getAnswerArrayWithoutDiscriptiveCount = 0;
    allTeacherAnswersArray.map((questions, index) => {
      if (questions.answer != "") {
        getAnswerArrayWithoutDiscriptiveCount += 1;
      }
    })

    if (getAnswerArrayWithoutDiscriptiveCount == getQuestionsID.length) {
      axios.post(config.API_URL + 'submitAllStudentFeedback', {
        ragisterUserId: userLoginDetails.LoginUserId,
        submittedFeedbackType: "Teacher",
        userRole: userLoginDetails.role_master_auto_id,
        currentAcademicYear: userLoginDetails.currentAcademicYear,
        classSemester: "",
        answersArray: allTeacherAnswersArray
      }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      }).then(function (response) {
        if (response.data.status.status == 1) {
          toast.success(response.data.status.message);
          localStorage.removeItem("userDetailsLog");
          localStorage.removeItem("isAuthenticated");
          localStorage.clear();
          navigate('/ThankYou');
        }
      }).catch(function (error) {
        toast.error(error);
      });
    } else {
      getQuestionsID.map((questions, index) => {
        let checkValidation = allTeacherAnswersArray.find(o => o.question_id === questions);
        if (!checkValidation) {
          var element = document.getElementById("studentInfra" + questions);
          element.classList.add("error");
        }
      });
      toast.error("All questions are compulsory.");
    }
  }

  function getAllTeacherQuestions() {
    setComponentLodignState(true);
    axios.post(config.API_URL + 'getTeacherFeedbackQuestion', {
      userId: userLoginDetails.LoginUserId
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        // console.log(response.data.data);
        if (response.data.data != null && response.data.data != "") {
          setTeacherQuestionsArray(response.data.data);
        } else {
          setTeacherQuestionsArray([]);
        }
        setComponentLodignState(false);
      }
    }).catch(function (error) {
      toast.error(error);
      setComponentLodignState(false);
    });
  }


  const onItemClick = useCallback(event => {
    // console.log(event.target.value);
    let Obj = {};
    if (event.target.getAttribute('q_type') !== "Descriptive") {
      Obj = {
        question_id: event.target.getAttribute('questionid'),
        subject_id: "",
        teacher_id: "",
        answer: event.target.getAttribute('questionanswer'),
        description: ""
      }
    } else {
      Obj = {
        question_id: event.target.getAttribute('questionid'),
        subject_id: "",
        teacher_id: "",
        answer: "",
        description: event.target.value
      }
    }

    if (allTeacherAnswersArray.length == 0) {
      allTeacherAnswersArray.push(Obj)
      setTeacherAnswersArray(allTeacherAnswersArray);
    } else {
      let checkNewPushBit = true;
      let obj = allTeacherAnswersArray.find((o, i) => {
        if (o.question_id === event.target.getAttribute('questionid')) {
          allTeacherAnswersArray[i] = Obj;
          checkNewPushBit = false;
        }
      });
      if (checkNewPushBit) {
        allTeacherAnswersArray.push(Obj)
      }
      setTeacherAnswersArray(allTeacherAnswersArray);
    }
    var element = document.getElementById("studentInfra" + event.target.getAttribute('questionid'));
    element.classList.remove("error");
    // console.log(allTeacherAnswersArray);
    // var target = event.target;
    // var parent = target.parentElement.parentElement;//parent of "target"
  }, [allTeacherQuestionsArray]);

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/');
  }

  let saveAndClose = () => {
    setModelPopupStatus(false);
    navigate('/TeacherDashboard');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.mstr_student_teacher_first_name}&nbsp;{userLoginDetails.mstr_student_teacher_last_name}&nbsp;</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Teacher Feedback</div>
          </div>
          </div>
        </section>
        {componentLodignState == true ?
          <div class="loader-bg">
            <h3>Please Wait...</h3>
            <div class="loader">
              <span></span>
            </div>
          </div>
          :
          <section className='section-survey section-surveyStudentInfrastructure'>
            <div className="row">
              <div className="col-md-12">
                <div className='info info-white'>Fields marked with <em>*</em> are mandatory</div>
                <div className='questionnnaire-wrapper'>
                  <div className='grid-row row-header sticky'>
                    <div className='column col-srno'>#</div>
                    <div className='column col-question'><div className='column-content'> &nbsp;</div></div>
                    <div className='column col-grade'>Strongly Agree</div>
                    <div className='column col-grade'>Agree</div>
                    <div className='column col-grade'>Neutral</div>
                    <div className='column col-grade'>Disagree</div>
                    <div className='column col-grade'>Strongly Disagree</div>
                  </div>
                  {
                    Object.keys(allTeacherQuestionsArray).length >= 1 ?
                      Object.keys(allTeacherQuestionsArray).map(function (key, index) {
                        return <CommonComponentForQuestionsAndOption term={allTeacherQuestionsArray[key]} objectKey={key} onItemClick={onItemClick} srNo={index + 1} />
                      })
                      : null
                  }
                </div>
              </div>
              <div className='col-md-12'>
                <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={onSubmitTeacherFeedbackClick}>Submit</button>
              </div>
            </div>
          </section>
        }
        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
      <Modal
        show={modelPopupStatus}
        backdrop="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body>
          <div className="font-robo">
            <div className="">
              <div className="card card-1 " style={{ boxShadow: 'none' }}>
                {/* <div className="logo-holder">
                  <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                  <div className='feedback-title' >Feedback System</div>
                </div> */}
                <div className="card-body card-thankyou" style={{ padding: '5px 5px', textAlign: 'center' }}>
                  <center>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                      <circle className="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                      <polyline className="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                    </svg>
                  </center>
                  <div className='message-submitThankyou'>
                    <h3>Feedback submitted successfully.<br />
                      Thank you for your valuable time.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <center>
            <button className='btn btn-primary btn-submitForm' style={{ display: 'block' }} onClick={saveAndClose}>
              Back to Main Page
            </button>
          </center>
        </Modal.Footer>
      </Modal>
    </div>
  )
}